import { Injectable } from "@angular/core";
import { HttpClient} from '@angular/common/http';
import { ToastrService } from "ngx-toastr";
import { HttpService } from "src/app/core/services/http-service";
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { Router } from "@angular/router";


@Injectable({
  providedIn: "root",
})
export class MaterialMarketingService extends HttpService {
  constructor(
    http: HttpClient,
    router: Router,
    toastService: ToastrService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    super(http, router, toastService, platformId);
  }
  public buscaMaterialMarketinPorGrupo(grupo: number, callback, erorCallBack) {
    this.get(`material-marketing/${grupo}`, callback, erorCallBack);
  }

  public listarGrupos(callback, erorCallBack) {
    this.get("material-marketing/grupos", callback, erorCallBack);
  }
}
